import STRINGS from '../localisation/Strings';

const useStrings = (): [typeof STRINGS] => [STRINGS];

export default useStrings;
